import React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import { useTranslation } from "react-i18next";
import { DialogContainer } from "assets/css/globle";
export default function AlertModal({
  handleOnSubmit,
  handleOnClose,
  title,
  content,
  isOpen,
  setOpenAlert,
  validation
}) {

  const { t } = useTranslation();

  const [fullWidth] = React.useState(true);

  const handleOnNo = () => {
    if(handleOnClose) {
      handleOnClose();
    }
    
    setOpenAlert(false);
  }

  return (
    <Dialog
      open={isOpen}
      onClose={() => setOpenAlert(false)}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      maxWidth="xs"
      sx={{ zIndex: 10001 }}
      fullWidth={fullWidth}
    >
      <DialogContainer>
        <h2 className="header">{title}</h2>
        <p className="content">{content}</p>
        <DialogActions className="action-wrapper">
          {validation && (
            <>
              <Button onClick={() => setOpenAlert(false)}>{t("Ok")}</Button>
            </>
          )}
          {!validation && (
            <>
              <Button onClick={handleOnSubmit} autoFocus>
                {t("Yes")}
              </Button>
              <Button
                onClick={() => handleOnNo()}
              >
                {t("No")}
              </Button>
            </>
          )}
        </DialogActions>
      </DialogContainer>
    </Dialog>
  );
}
